/*====== import  ======*/
/*------ React ------*/
import React from "react"

/*------ CSS ------*/
import styled from 'styled-components';
/*------ Component Js/Jsx ------*/
import { Header } from "02CommonUiParts/OtherParts/Header";
import { Navigate, useLocation } from "react-router-dom";
// import { useMsal } from "@azure/msal-react";
// import { Navigate } from "react-router-dom";
import { USERINFO_STORAGE } from "03CommonApiParts/CodeDefinition";
/*====== Styles  ======*/
/*------ Styled Components ------*/
const SdivMain = styled.div`
	min-width: 100%;
`;

/*====== global variables ======*/
/*====== global functions ======*/

/*==================*/
/*=====  Main  =====*/
/*==================*/
export const PrivateRoute = (props) =>{
	const { children } = props;
	/*====== Instance  ======*/
	const location = useLocation();
	/*====== reack-hook-form  ======*/
	/*====== variables ======*/
	/*====== state  ======*/
	/*====== functions  ======*/
	/*------ リロード時・タブ終了時・ブラウザ終了時などに確認ダイアログを表示　------*/
	// (() => {
	// 	// 'use strict';
	// 	let isSubmit = false;
	// 	let userGestureExists = false;

	// 	//クリックとキー押下でuserGestureExistsをtrueに変更
	// 	const setTrue = () => { userGestureExists = true; }
	// 	for (const v of ['click', 'keydown']) {
	// 		window.addEventListener(v, setTrue(), { once: true });
	// 	}

	// 	//isSubmitがfalseでuserGestureExistsがtrueならダイアログが表示されるようになる
	// 	window.addEventListener('beforeunload', e => {
	// 		if (!isSubmit && userGestureExists) {
	// 			e.preventDefault();
	// 			e.returnValue = 'このページから移動しますか？ 入力した情報は保存されない可能性があります。';
	// 		}
	// 	});
	// 	document.addEventListener('DOMContentLoaded', () => {
	// 		document.getElementsByTagName('button')[0].addEventListener('click', () => { isSubmit = true; });
	// 	});
	// })();
	const userData = sessionStorage.getItem(USERINFO_STORAGE);
	/*====== data  ======*/
	/*--------------------------*/
	/*------ Start Render ------*/
	/*--------------------------*/
    return(
		// accounts[0] ?
		// //認証済みの場合
		// <>
		// 	<Header/>
		// 	<SdivMain>
		// 	{children}
		// 	</SdivMain>
		// </>
		// :
		// <Navigate to='/'/>
		userData ?
			//認証済みの場合
		<>
			{/* 画面が一覧だったら子要素の幅に合わせない、それ以外だったら子要素の幅に合わせる */}
			<SdivMain id="main" style={{width: location.pathname.includes('list') ? null : 'fit-content'}}>
				<Header/>
				{children}
			</SdivMain>
		</>
        :
		// sessionStorage.setItem(PATH_STORAGE, JSON.stringify(pathValue)),
		<Navigate to='/'/>//認証情報がない場合はルートディレクトリに遷移
    );
}

